<template>
  <a-list
    itemLayout="horizontal"
    :dataSource="data"
  >
    <a-list-item slot="renderItem" slot-scope="item,index" :key="index">
      <a-list-item-meta>
        <a slot="title">{{ item.title }}</a>
        <span slot="description">
          <span class="security-list-description">{{ item.description }}</span>
          <span v-if="item.value"> : </span>
          <span class="security-list-value">{{ item.value }}</span>
        </span>
      </a-list-item-meta>
      <template v-if="item.actions">
        <a slot="actions" @click="item.actions.callback">{{ item.actions.title }}</a>
      </template>
    </a-list-item>
    <a-modal
      title="密码修改"
      :width="380"
      v-model="visible"
      :footer="null"
    >
      <a-form :form="form">
        <a-form-item v-show="false" >
          <a-input v-decorator="[ 'id', {rules: []} ]" />
        </a-form-item>
        <a-form-item label="原密码">
          <a-input
            type="password"
            placeholder="原密码"
            v-decorator="['oldPassword', {rules: [{ required: true, message: '请输入原密码' }, { validator: this.oldPasswordCheck }]}]"
          />
        </a-form-item>
        <a-popover placement="rightTop" trigger="click" :visible="state.passwordLevelChecked">
          <template slot="content">
            <div :style="{ width: '240px' }" >
              <div :class="['user-register', passwordLevelClass]">强度：<span>{{ passwordLevelName }}</span></div>
              <a-progress :percent="state.percent" :showInfo="false" :strokeColor=" passwordLevelColor " />
              <div style="margin-top: 10px;">
                <span>请至少输入 6 个字符。请不要使用容易被猜到的密码。</span>
              </div>
            </div>
          </template>
          <a-form-item>
            <a-input
              v-decorator="['stuPassword', {rules: [{ required: true, message: '至少6位密码，区分大小写' }, { validator: this.handlePasswordLevel },{min:6,message:'至少输入6位密码'},{max:18,message:'最多输入18位密码'}], validateTrigger: ['change', 'blur']}]"
              type="password"
              @click="handlePasswordInputClick"
              autocomplete="false"
              placeholder="至少6位密码，区分大小写"></a-input>
          </a-form-item>
        </a-popover>

        <a-form-item>
          <a-input
            v-decorator="['password2', {rules: [{ required: true, message: '至少6位密码，区分大小写' }, { validator: this.handlePasswordCheck }], validateTrigger: ['change', 'blur']}]"
            type="password"
            autocomplete="false"
            placeholder="确认密码"></a-input>
        </a-form-item>

      </a-form>
      <div style="borderTop: 1px solid #e9e9e9; padding: 10px 16px; background: #fff; textAlign: right">
        <a-button
          @click="onClose"
          style="margin-right: 10px "
        >
          返回
        </a-button>
        <a-button
          :disabled="disabled"
          @click="onSubmit"
          type="primary"
        >
          提交
        </a-button>
      </div>
    </a-modal>
    <a-modal
      :title="titlePho ? '密保手机修改' : '绑定密保手机'"
      :width="380"
      v-model="visiblePho"
      :footer="null"
    >      <a-spin
      :spinning="loading"
      tip="Loading..."
    >
      <div>
        <a-form :form="form">
          <a-form-item label="手机号" :required="true">
            <a-input
              style="width: 300px"
              placeholder="请输入手机号"
              v-decorator="['stuTel', {rules: [{ validator: this.handlePhoneCheck }], validateTrigger: 'blur'}]"
            />
          </a-form-item>
          <a-row :gutter="12">
            <a-col
              :span="12"
            >
              <a-form-item label="验证码">
                <a-input
                  style="width: 200px"
                  placeholder="验证码"
                  v-decorator="['smsCode', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]"
                >
                  <a-icon
                    slot="prefix"
                    type="mail"
                    :style="{ color: 'rgba(0,0,0,.25)' }"
                  />
                </a-input>
              </a-form-item>
            </a-col>
            <a-col
              :span="3"
            >
              <a-button
                :disabled="state.smsSendBtn"
                @click.stop.prevent="getCode"
                v-text="!state.smsSendBtn && '获取验证码'||(state.time+' s')"
                style="width:100px;marginTop:43px;marginLeft:35px"
                type="primary">发送验证码</a-button>
            </a-col>
          </a-row>
        </a-form>

      </div>
      <div style="borderTop: 1px solid #e9e9e9; padding: 10px 16px; background: #fff; textAlign: right">
        <a-button
          @click="onClosePho"
          style="margin-right: 10px "
        >
          返回
        </a-button>
        <a-button
          :disabled="disabled"
          @click="onSubmitPho"
          type="primary"
        >
          提交
        </a-button>
      </div>
    </a-spin>
    </a-modal>
    <a-modal
      title="备用邮箱修改"
      :width="380"
      v-model="visibleMail"
      :footer="null"
    >
      <div>
        <a-form>
          <a-form-item label="邮箱">
            <a-input
              style="width: 310px"
              placeholder="邮箱"
              v-model="mail"
            />
          </a-form-item>
          <a-form-item label="验证码">
            <a-input
              style="width: 150px"
              placeholder="验证码"
              v-model="verificationCodeMail"
            />
            <a-button v-show="showMail" style="margin-left: 8px;width:100px" type="primary" @click="getCodeMail">发送验证码</a-button>
            <a-button v-show="!showMail" style="margin-left: 8px;width:100px;background-color:white;color:#1890ff" type="primary">{{ countMail }} s</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div style="borderTop: 1px solid #e9e9e9; padding: 10px 16px; background: #fff; textAlign: right">
        <a-button
          @click="onCloseMail"
          style="margin-right: 10px "
        >
          返回
        </a-button>
        <a-button
          :disabled="disabled"
          @click="onSubmitMail"
          type="primary"
        >
          提交
        </a-button>
      </div>
    </a-modal>
  </a-list>
</template>
<script>
import { getStudent, updatePassword, checkPassword, checkPhone, getSmsCaptcha, putObjPho } from '@/api/user/register'
const levelNames = {
  0: '低',
  1: '低',
  2: '中',
  3: '强'
}
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
}
export default {
  data () {
    return {
      loading: false,
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
      labelCol: {
        xs: { span: 14 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 10 },
        sm: { span: 14 }
      },
      titlePho: false,
      show: true,
      showMail: true,
      count: '',
      countMail: '',
      form: this.$form.createForm(this),
      timer: null,
      visiblePho: false,
      visible: false,
      visibleMail: false,
      password: '',
      password2: '',
      OriginalPassword: '',
      mail: '',
      verificationCodePho: '',
      phone: '',
      verificationCodeMail: '',
      current: 0,
      disabled: false,
      data: [
        {
          title: '账户密码',
          // description: '当前密码强度',
          // value: '强',
          actions: {
            title: '修改',
            callback: () => {
              this.visible = true
            }
          }
        },
        {
          title: '密保手机',
          description: '绑定后可用手机号登录，忘记密码时可用密保手机找回密码',
          value: '',
          actions: {
            title: '绑定',
            callback: () => {
              this.visiblePho = true
            }
          }
        },
        {
          title: '邮箱',
          // description: '绑定邮箱',
          // value: '',
          actions: {
            title: '敬请期待',
            callback: () => {

            }
          }
        }
      ]
    }
  },
  computed: {
    passwordLevelClass () {
      return levelClass[this.state.passwordLevel]
    },
    passwordLevelName () {
      return levelNames[this.state.passwordLevel]
    },
    passwordLevelColor () {
      return levelColor[this.state.passwordLevel]
    }
  },
  created () {
    this.getlist()
  },
  methods: {
    getlist () {
      getStudent().then(res => {
        this.datatype = res.result
        this.data[1].value = res.result.stuTel
        if (this.data[1].value != null && this.data[1].value !== '') {
          this.data[1].description = '已绑定手机'
          this.data[1].actions.title = '修改'
          this.titlePho = true
        }
        this.form.setFieldsValue({
          id: this.datatype.id
        })
      })
    },

    handlePhoneCheck (rule, value, callback) {
      if (value && !/^1[0-9]\d{9}$/.test(value) && value !== '') {
        callback(new Error('格式不正确，请输入正确的手机号码'))
        return false
      } else if (!value || value === '') {
        callback(new Error('请输入手机号'))
        return false
      } else {
        checkPhone(value).then(res => {
          if (res.result >= 1) {
            callback(new Error('系统已存在此手机号码，请重新输入'))
            return false
          } else {
            callback()
          }
        })
      }
    },
    getCode (e) {
      e.preventDefault()
      const that = this
      this.form.validateFields(['stuTel'], { force: true },
        (err, values) => {
          if (!err) {
            this.state.smsSendBtn = true
            const interval = window.setInterval(() => {
              if (that.state.time-- <= 0) {
                that.state.time = 60
                that.state.smsSendBtn = false
                window.clearInterval(interval)
              }
            }, 1000)
            const hide = this.$message.loading('验证码发送中..', 0)
            getSmsCaptcha(values.stuTel).then(res => {
              setTimeout(hide, 2000)
            }).catch(err => {
              setTimeout(hide, 1)
              clearInterval(interval)
              that.state.time = 60
              that.state.smsSendBtn = false
              this.requestFailed(err)
            })
          }
        }
      )
    },
    requestFailed (err) {
      console.log('err' + err)
      this.$notification['error']({
        message: '错误',
        description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
        duration: 4
      })
      this.registerBtn = false
    },
    handlePasswordLevel (rule, value, callback) {
      let level = 0

      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.state.passwordLevel = level
      this.state.percent = level * 30
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100
        }
        callback()
      } else {
        if (level === 0) {
          this.state.percent = 10
        }
        callback()
      }
    },
    handlePasswordInputClick () {
      if (!this.isMobile()) {
        this.state.passwordLevelChecked = true
        return
      }
      this.state.passwordLevelChecked = false
    },
    handlePasswordCheck (rule, value, callback) {
      const password = this.form.getFieldValue('stuPassword')
      if (value === undefined) {
        callback(new Error('请输入密码'))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error('两次密码不一致'))
      }
      callback()
    },
    getCodeMail () {
      var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!reg.test(this.mail)) {
        this.$message.error('邮箱格式不正确')
        return false
      }
      const TIME_COUNT_MAIL = 60
      if (!this.timer) {
        this.countMail = TIME_COUNT_MAIL
        this.showMail = false
        this.timer = setInterval(() => {
          if (this.countMail > 0 && this.countMail <= TIME_COUNT_MAIL) {
            this.countMail--
          } else {
            this.showMail = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    oldPasswordCheck (rule, value, callback) {
      if (value !== '') {
        checkPassword(value).then(res => {
          if (res === false) {
            callback(new Error('密码错误，请重新输入'))
            return false
          } else {
            callback()
          }
        }).catch(() => {
          this.$message.error('验证失败！服务器抢救中...')
        })
      } else {
        callback()
      }
    },
    onClose () {
      this.visible = false
    },
    onSubmit () {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.stuPassword !== values.password2) {
            this.$message.error('两次密码不一致')
            return false
          } else {
            values.id = this.datatype.id
            updatePassword(values).then(res => {
              this.$message.success('修改成功')
              this.visible = false
            }).catch(() => {
              this.$message.error('修改失败')
              this.visible = false
            }).finally(() => {
              this.form.resetFields()
            })
          }
        }
      })
    },
    onClosePho () {
      this.visiblePho = false
      this.getlist()
    },
    onSubmitPho (e) {
      e.preventDefault()
      const _this = this
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          putObjPho(values).then((res) => {
            if (res.result === -1) {
              this.$message.error('验证码已失效,请重新获取')
            } else if (res.result === -2) {
              this.$message.error('验证码不正确,请重新输入')
            } else {
              if (_this.titlePho) {
                this.$message.success('修改成功')
                this.visiblePho = false
              } else {
                this.$message.success('绑定成功')
                this.visiblePho = false
              }
            }
          }).catch(() => {
            this.$message.error('绑定失败')
          }).finally(() => {
            this.form.resetFields()
            this.loading = false
            this.getlist()
          })
        }
      })
    },
    onCloseMail () {
      this.visibleMail = false
      console.log(222)
    },
    onSubmitMail () {
      var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!reg.test(this.mail)) {
        this.$message.error('邮箱格式不正确')
        return false
      }
      if (this.verificationCodeMail === '123456') {
        this.$message.success('修改成功')
        this.onCloseMail()
      } else {
        this.$message.error('验证码不正确')
        return false
      }
    }
  }
}
</script>

<style scoped>

</style>
